export default __webpack_public_path__ + "static/menu_resource-20050614c603dca00de2d72e434a1602.png";